import cn from "classnames";
import { Box } from "@mui/material";

import { Bet } from "./Bet";
import { Players } from "./Players";
import { PlayOrWatchButton } from "./PlayOrWatchButton";
import { Rounds } from "./Rounds";
import { useStyles } from "./styles";
import { Time } from "./Time";
import { Type } from "./Type";
import { GameCreateTime, GameCreateFen } from "src/store/models";
import useWindowSize from "src/hooks/useWindowSize";
import { MAX_XL_TABLET } from "src/pages/game-new2/constants";

import { IUserNew } from "src/store/models";
import {GameType} from "../../../../store/lobbyStore";
import {GameModeCreate} from "../../../../service/api/lobby/requestResponses";

interface IPlayer {
    id: string;
    avatarUrl: string;
    nickname: string;
    stars?: number;
}

interface IGameItemProps {
    id: string;
    amount: number;
    rounds: number;
    // time: 3 | 5 | 10 | 20;
    createdAt: string;
    time: GameCreateTime;
    type: GameCreateFen;
    gameType: GameModeCreate;
    player1: IPlayer;
    player2?: IPlayer;
    status: string;
    me?: IUserNew;
}

export const GameItem = ({
    me,
    id,
    amount,
    rounds,
    time,
    type,
    gameType,
    player1,
    player2,
    status,
    createdAt,
}: IGameItemProps) => {
    const classes = useStyles();
    const { width } = useWindowSize();
    const isMobile = width < MAX_XL_TABLET;
    const isFreePlay = document.location.href.indexOf('lobby-free-play') > 0;

    if (isMobile) {
        return (
            <Box
                component="div"
                className={cn(classes.wrapperGameItem, {
                    isMobile: isMobile,
                    isFreePlay: isFreePlay,
                })}
            >
                <Bet amount={amount} isMobile={isMobile} />
                <Time time={time} isMobile={isMobile} />
                <div
                    className={cn(classes.roundsAndType, {
                        isMobile: isMobile,
                    })}
                >
                    <Rounds rounds={rounds} isMobile={isMobile} isMatch={gameType === 2} />
                    <Type type={type} isMobile={isMobile} />
                </div>
                <Players
                    player1={player1}
                    player2={player2}
                    createdAt={createdAt}
                    isMobile={isMobile}
                    me={me}
                />
                <PlayOrWatchButton
                    id={id}
                    player1={player1}
                    player2={player2}
                    isMobile={isMobile}
                    createdAt={createdAt}
                />
            </Box>
        );
    }

    return (
        <Box
            component="div"
            className={cn(classes.wrapperGameItem, {
                isMobile: isMobile,
                isFreePlay: isFreePlay,
            })}
        >
            <Bet amount={amount} />
            <Time time={time} />
            <Rounds rounds={rounds} isMatch={gameType === 2} />
            <Type type={type} />
            <Players
                player1={player1}
                player2={player2}
                createdAt={createdAt}
            />
            <PlayOrWatchButton
                id={id}
                player1={player1}
                player2={player2}
                createdAt={createdAt}
            />
        </Box>
    );
};
